<div
    class="info-box"
    [ngClass]="[backgroundColor(), floatBox()]"
>
    <h3>{{ headline() }}</h3>
    @if (bulletPoints().length) {
        <ul>
            @for (bulletPoint of bulletPoints(); track bulletPoint) {
                <li>{{ bulletPoint }}</li>
            }
        </ul>
    }
    <ng-content></ng-content>
</div>
